import DDLogger from "./utils/dd-logger";

export const initLogger = (botName: string | undefined, hostName: string) => {
    DDLogger.getInstance(botName, hostName);
};
